<template>
  <div v-if="ready" ref="tourWindow" v-click-outside="closeTour" :style="position" class="tour-window"
       role="dialog"
       aria-modal="true"
       aria-labelledby="tour-window-title"
       aria-describedby="tour-window-text tour-window-step"
       tabindex="-1">
    <div>
      <div :style="arrowPos" class="arrow"></div>
      <div class="tour-window-root">
        <div class="heading"> </div>

        
        <div class="content" aria-live="polite">
          <div id="tour-window-title" class="item-name">{{ tourData.title }}</div>
          <span id="tour-window-text">{{ tourData.text }}</span>
          <span id="tour-window-step" class="sr-only">{{ index + 1 }} {{ content.of }} {{ totalItems }}</span>
        </div>
        <div class="buttons">
          <button ref="skipButton" :aria-label="skipCaption" class="flyer-tour-btn skip-button" :class="{lastItem:isLastItem}" @click="skip">
            <img :src="getIcon()" alt="" class="icon-close">
            <span>{{ skipCaption }}</span>
          </button>

          <div class="progress-track" ref="progressTrack" :class="{lastItem:isLastItem}" aria-hidden="true">
            <span class="progress-thumb" ref="progressThumb">
<!--                {{ `${index + 1} ${content.of} ${totalItems}` }}-->
            </span>
          </div>

          <button ref="nextButton" :aria-label="nextCaption" class="flyer-tour-btn next" :class="{lastItem:isLastItem}" @click="next">
            <span>{{ nextCaption }}</span>
            <img src="/images/icon-chevron.svg" alt="" class="icon-chevron">
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import ClickOutside from 'vue-click-outside'
import featureMixin from "@/mixins/featureMixin";
import Lytics from "@/classes/Lytics";
//import AppConfig from "@/classes/AppConfig";

function calcDist(p1, p2) {
  return Math.sqrt((p2.x - p1.x) ^ 2 + (p2.y - p1.y) ^ 2);
}

export default {
  name: "TourWindow",
  mixins: [featureMixin],
  data() {
    return {
      featurePath: 'tour',
      items: [],
      index: 0,
      position: null,
      arrowPos: null,
      padding: 10,
      subHeaderState: null,
      ready: false,
      filteredItems: [],
      lastFocusedElement: null
    }
  },
  directives: {
    ClickOutside
  },
  computed: {
    ...mapGetters(['content', 'highlightResults']),
    ...mapGetters('filters', ['isFilterPanelOpen']),
    tourOrder() {
      return [
        'sidebar',
        'fullscreen',
        'searchFilter',
        this.highlightResults ? null : 'search',
        'filterCategories',
        'discountFilter',
        'clearDiscount',
        'exitSearch',
        'zoom',
        'orientation',
        'pdf',
        'otherFlyers',
        'shoppingList',
        'storeLocator',
        'help',
      ].filter(item => item !== null);
    },
    isVisible() {
      return this.ready;
    },
    tourData() {
      return this.content.walkthrough[this.tourId] || {};
    },
    tourId() {
      return this.filteredItems[this.index];
    },
    nextCaption() {
      if (this.isLastItem) return this.content.finish;
      return this.content.next;
    },
    skipCaption() {
      if (this.isLastItem) return this.content.restart;
      return this.content.skipTour;
    },
    isLastItem() {
      return this.index == (this.totalItems - 1)
    },
    totalItems() {
      return this.filteredItems.length;
    },
    includeFilterPanel() {
      return this.config?.includeFilterPanel;
    }
  },
  mounted() {
    if(this.includeFilterPanel) {
      this.subHeaderState = this.isFilterPanelOpen;
      this.setFilterPanelState(true);
    }

    /*if(AppConfig.AppConf?.title.toLowerCase().includes("ct".toLowerCase()))
        this.setFilterPanelState(true);*/
    this.$nextTick(() => {
          setTimeout(() => {
            const ti = document.querySelectorAll("[data-tour-item]");
            /*	console.log('Tour Items:', ti)*/
            if (ti.length < 1) {
              this.dismissTour();
              return;
            }
            this.items = [];
            ti.forEach((node) => {
              this.items.push({
                node,
                item: node.getAttribute('data-tour-item'),
                rect: node.getBoundingClientRect(),
                dist: calcDist({x: 0, y: 0}, node.getBoundingClientRect())
              })
              //this.items.push(node.getAttribute('data-tour-item'))
            })

            // console.log('Items Rects:', this.items);

            this.filteredItems = this.items.filter((item) => {
              return item.rect.width && item.rect.height && this.content.walkthrough[item.item];
            }).sort((a, b) => {
              return a.rect.left - b.rect.left;
            }).map((item) => {
              return item.item;
            })

            // console.log('Filtered Tour Items:', this.filteredItems);

            /*this.filteredItems = this.tourOrder.filter((item) => {
              return this.items.includes(item);
            })*/


            this.refresh();
            this.observer = new ResizeObserver(this.refresh);
            this.observer.observe(document.querySelector('#app'));
            this.ready = true;
            this.activateTourFocus();
          }, 100);

        }
    )
    Lytics.TriggerTutorialViews();
  },

  beforeDestroy() {
    if(this.includeFilterPanel) {
      this.setFilterPanelState(this.subHeaderState);
    }
    if (this.observer) this.observer.disconnect();
    this.deactivateTourFocus();
  },

  methods: {
    ...mapActions('toast', ['dismissTour']),
    ...mapActions('filters', ['setFilterPanelState']),
    refresh() {
      // if(window.innerWidth < 1200){
      if (window.innerWidth < 1023) {
        this.dismissTour();
        return;
      }
      const tourWindow = document.querySelector('.tour-window');
      if (!tourWindow) return;
      const item = document.querySelector(`[data-tour-item='${this.tourId}']`);
      const container = document.querySelector('#app').getBoundingClientRect();
      let pos = null;
      let arrowPos = null
      if (item) {

        const bounds = item.getBoundingClientRect();
        const wb = tourWindow.getBoundingClientRect();
        let targetMid = bounds.left + (bounds.width / 2);

        let left = bounds.left - (wb.width - bounds.width) / 2;
        let bottom = bounds.bottom + this.padding;

        if (left < container.left) {
          left = container.left + this.padding;
        }

        if (left + wb.width > container.right) {
          left = (container.right - wb.width) - this.padding;
        }

        pos = {
          top: bottom + 'px',
          left: left + 'px'
        }

        arrowPos = {
          left: 'calc(50% + ' + (targetMid - (left + wb.width / 2)) + 'px)'
        }

      }
      this.position = pos;
      this.arrowPos = arrowPos;
    },
    getIcon(){
      return !this.isLastItem ? '/images/icon-close-red.svg' : '/images/icon-restart.svg'
    },
    next() {
      if (this.isLastItem) {
        this.dismissTour(true);
        Lytics.TriggerTutorialComplete(this.totalItems);
      } else {
        if (this.index < this.items.length - 1) this.index++;
        this.moveThumb()
        this.refresh()
      }
    },
    moveThumb(){
      const progressTrackWidth = this.$refs.progressTrack.offsetWidth;
      const thumbWidth = this.$refs.progressThumb.offsetWidth;
      const maxMovement = progressTrackWidth - thumbWidth;

      const movement = (this.index / (this.totalItems-0.9))*maxMovement;
      const maxThumbPosition = progressTrackWidth - thumbWidth
      this.$refs.progressThumb.style.left = Math.min(movement, maxThumbPosition) + 0.8 + 'px'
    },
    prev() {
      if (this.index > 0) this.index--;
      this.refresh();
    },
    skip() {
      if (!this.isLastItem) {
        this.dismissTour(true);
        Lytics.TriggerTutorialSkip(this.index + 1, this.totalItems)
      } else {
        this.index = 0;
        this.moveThumb()
        this.refresh();
      }

    },
    closeTour() {
      console.log('closeTour')
      this.dismissTour(true);
    },
   
    activateTourFocus() {
      this.lastFocusedElement = document.activeElement;
      document.addEventListener('keydown', this.onTourKeydown);
      this.$nextTick(() => {
        this.$refs.tourWindow?.focus();
      });
    },

    deactivateTourFocus() {
      document.removeEventListener('keydown', this.onTourKeydown);
     
      const restoreTo = (this.lastFocusedElement && document.contains(this.lastFocusedElement) && this.lastFocusedElement.offsetParent !== null)
          ? this.lastFocusedElement
          : document.querySelector('[data-tour-item="help"]');
      restoreTo?.focus();
      this.lastFocusedElement = null;
    },

    getFocusableElements() {
      if (!this.$refs.tourWindow) return [];
      return Array.from(this.$refs.tourWindow.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(el => el.offsetParent !== null);
    },

    onTourKeydown(e) {
      if (e.key === 'Escape') {
        e.stopPropagation();
        this.closeTour();
        return;
      }
      if (e.key !== 'Tab') return;
      const focusable = this.getFocusableElements();
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      // Focus drifted outside the tour - pull this Tab press back into it.
      const container = this.$refs.tourWindow;
      const isInsideTour = container && container.contains(document.activeElement);
      if (!isInsideTour) {
        e.preventDefault();
        (e.shiftKey ? last : first).focus();
        return;
      }

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.tour-window {
  position: absolute;
  z-index: 1000;
  font-size: 14px;
  width: 325px;
  transition: All 300ms;

  * {
    transition: All 300ms;
  }

  filter: drop-shadow(2px 2px 3px #000);

  .tour-window-root {
    border-radius: 4px;
    overflow: hidden;
    background-color: #fff;

    .heading {
      display: flex;
      justify-content: space-between;
      background-color: var(--secondary-color);
      color: var(--primary-text-color);
      border-bottom: 1px solid #eee;
      margin: 0;
      padding: 5px 10px;
    }

    .content {
      padding: 1em;
      display: flex;
      flex-direction: column;
      gap: 0.5em;
      line-height:20px;

      .item-name {
        font-family: 'Lato Bold', sans-serif;
        color: var(--secondary-color);
      }
    }
  }

  .buttons {
    padding: 0 0.9em 1em;
    display: flex;
    gap: 0.5em;
    justify-content: space-between;
    align-items: center;
  }

  .flyer-tour-btn{
    border: none;
    white-space: nowrap;
    padding: 0;
    display:flex;
    justify-content: space-between;
    align-items: center;
    font-family: 'Lato Bold', sans-serif;
  }
  .flyer-tour-btn.lastItem{
    white-space: pre-wrap;
  }

  .flyer-tour-btn.skip-button {
    color: #EE3124;

    &:focus {
      outline: none;
    }

    &:focus-visible {
     
      outline-offset: 2px;
    }

    span:hover{
      filter:brightness(90%);
    }

    &:hover {
      filter: none;
    }

    .icon-close{
      width:1em;
      margin-right:5px;
    }
    .icon-close:hover{
      filter:brightness(90%)
    }
  }

  .progress-track{
    background: #E6E6E6;
    width: 39%;
    height: 5px;
    border-radius:10px;
    position: relative;

    .progress-thumb{
      background: #c8c9c7;
      border-radius:10px;
      position:absolute;
      height: 100%;
      width: 20px;
      transition: left 0.5s ease;
    }
  }
  .progress-track.lastItem{
    margin-left:-5px;
  }

  .flyer-tour-btn.next.lastItem{
    padding-left: 10px;
  }

  .flyer-tour-btn.next{
    color: var(--tertiary-color);


    span:hover{
      filter:brightness(90%);
    }

    &:hover {
      filter: none;
    }

    .icon-chevron{
      width:1em;
      margin-left:5px;
    }
    .icon-chevron:hover{
      filter:brightness(90%)
    }

  }


  .arrow {
    position: absolute;
    transform: translate(-50%, -50%) rotateZ(45deg);
    width: 12px;
    height: 12px;
    background-color: var(--secondary-color);
    top: 0;
    z-index: -1;
  }
}

// @media (max-width: 1023px) {
//      .tour-window {
//       display: none;
//     }
// }

</style>